var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"play-button",attrs:{"type":"button"},on:{"click":_vm.toggleAudio}},[_c('span',[_c('span',[_c('span',[(_vm.playing)?_c('span',[_vm._v("■")]):_vm._e(),(!_vm.playing)?_c('span',[_vm._v("▶︎")]):_vm._e()])])])])}
var staticRenderFns = []

export { render, staticRenderFns }